import { useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';
import { AlertManager } from '@dealroadshow/uikit-alert';
import CurrencyRepository from '@dm-portal/currency/CurrencyRepository';

export interface ICurrency {
  id: string,
  countryId: string | null,
  name: string,
  displayName: string,
  flagDisplayName: string,
  abbreviation: string,
  priority: number,
  active: boolean,
  color: string,
}

export default function useCurrencies() {
  const container = getContainer();
  const [isFetching, setIsFetching] = useState(false);
  const [collection, setCollection] = useState<ICurrency[]>([]);

  async function getCurrenciesList() {
    setIsFetching(true);

    try {
      const currencyRepository = container.get<CurrencyRepository>(CurrencyRepository);
      const response = await currencyRepository.getCurrencies();
      setCollection(response);
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
    } finally {
      setIsFetching(false);
    }
  }

  return {
    isFetching,
    collection,
    getCurrenciesList,
  };
}
